var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgTrash = function SvgTrash(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Trash' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.501 37.0454 13.501 15.0454 15.499 14.9544 16.499 36.9544"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.499 37.0454 23.501 36.9544 24.501 14.9544 26.499 15.0454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3877,6 L26.6127,6 L25.9627,4.051 C25.5537,2.824 24.4097,2 23.1167,2 L16.8827,2 C15.5897,2 14.4467,2.824 14.0367,4.051 L13.3877,6 Z M6.9507,46 L33.0487,46 L34.9487,8 L5.0517,8 L6.9507,46 Z M34.9507,48 L5.0487,48 L3.0487,8 L-0.0003,8 L-0.0003,6 L11.2797,6 L12.1397,3.419 C12.8217,1.374 14.7277,0 16.8827,0 L23.1167,0 C25.2727,0 27.1787,1.374 27.8607,3.419 L28.7207,6 L39.9997,6 L39.9997,8 L36.9507,8 L34.9507,48 Z"
  }));
};
SvgTrash = pure(SvgTrash);
SvgTrash.displayName = 'SvgTrash';
export default SvgTrash;